import { george, pr } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { GdsFakeActionButtonContainer } from "components/common/GdsFakeActionButtonContainer";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import { FormattedHTMLMessage } from "react-intl";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { IchAppRoutes } from "./IchAppRoutes";
import { IchAppStore } from "./IchAppStore";

type IProps = {
    store: IchAppStore
};

export const IchAppDeregistration = observer(({ store }: IProps) => {
    const [waitForDeregistration, setWaitForDeregistration] = React.useState(false);

    const handleClickContinue = async () => {
        try {
            setWaitForDeregistration(true);
            await store.postDeregistration();
            pushRoute(IchAppRoutes.DEREGISTRATION_SIGNING);
        } catch (error) {
            pushRoute("/error");
        } finally {
            setWaitForDeregistration(false);
        }
    };

    const handleClickBack = () => {
        pushRoute(IchAppRoutes.ROOT);
    };

    if (store.isLoading) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.Card
            elevated={false}
            style={{ borderRadius: 8 }}
        >
            <div style={{ lineHeight: "24px" }}>
                <div style={{ textAlign: "center", padding: "32px 16px" }}>
                    <pr.IconIchApp style={{ width: 88, height: 64 }} />
                    <pr.P_22_TITLE style={{ fontWeight: 700, lineHeight: "28px", textAlign: "center", marginTop: 8 }}>
                        <FormattedHTMLMessage id="ichApp.deregistration.title" />
                    </pr.P_22_TITLE>
                    <pr.P_16_CONTENT style={{ textAlign: "left", marginTop: 32 }}>
                        {ui.__("ichApp.deregistration.text")}
                    </pr.P_16_CONTENT>
                </div>
                <pr.LightSeparatorLine />
                <GdsFakeActionButtonContainer>
                    <GdsFakeActionButton
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                        color="primary"
                        onClick={handleClickContinue}
                        disabled={waitForDeregistration || !store.contactsStore.selectedEmailAddress}
                        isLoading={waitForDeregistration}
                    >
                        {ui.__("button.continue")}
                    </GdsFakeActionButton>

                    <GdsFakeActionButton
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                        onClick={handleClickBack}
                        disabled={waitForDeregistration}
                    >
                        {ui.__("common.back")}
                    </GdsFakeActionButton>
                </GdsFakeActionButtonContainer>
            </div>
        </george.Card>
    );
});




// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppDeregistration.tsx